// extracted by mini-css-extract-plugin
export var infoItem = "_sl-2";
export var title = "_sl-0";
export var value = "_sl-1";